import { createSlice } from "@reduxjs/toolkit";
import {
  getQuotesByUserURL,
  getToFundDataByURL
} from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import { commonErrMsg } from "../locales/en";

const initialState = {
  fundedLoader: false,
  toFundLoader: false,
  error: null
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getQuotesByUser.pending, (state) => {
        state.fundedLoader = true;
      })
      .addCase(getQuotesByUser.fulfilled, (state) => {
        state.fundedLoader = false;
      })
      .addCase(getQuotesByUser.rejected, (state, action) => {
        state.fundedLoader = false;
        showToast(
          action.payload?.data?.message || commonErrMsg.item2,
          showToastType.error
        );
      })
      .addCase(getToFundDataByUser.pending, (state) => {
        state.toFundLoader = true;
      })
      .addCase(getToFundDataByUser.fulfilled, (state) => {
        state.toFundLoader = false;
      })
      .addCase(getToFundDataByUser.rejected, (state) => {
        state.toFundLoader = false;
      });
  }
});

export const getQuotesByUser = createAsyncThunk(
  "invoice/getQuotesByUser",
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getQuotesByUserURL, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getToFundDataByUser = createAsyncThunk(
  "invoice/getToFundDataByUser",
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getToFundDataByURL, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export default invoiceSlice.reducer;
